// DensityToggle — the Data setup tables' row-height control. Extracted because
// both tabs rendered this block byte-for-byte: the label, the two icon-only
// segments and their aria names. The Density type lives here with its control.
//
// `density` belongs to the PAGE, not to a tab: it is a view preference that
// means the same thing on both tables, so it has to survive a tab switch —
// which is why this takes value/onChange rather than owning state.

import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@/components/common';

export type Density = 'default' | 'compact';

interface DensityToggleProps {
  value: Density;
  onChange: (next: Density) => void;
}

const DensityToggle = ({ value, onChange }: DensityToggleProps) => {
  const { t } = useTranslation();
  return (
    <div className='data-setup-page__view'>
      <span className='data-setup-page__view-label'>{t('data_setup_view')}</span>
      <SegmentedControl
        value={value}
        onChange={(v) => onChange(v as Density)}
        aria-label={t('data_setup_view')}
        options={[
          { value: 'default', icon: 'rows-3', ariaLabel: t('data_setup_view_comfortable') },
          { value: 'compact', icon: 'table-properties', ariaLabel: t('data_setup_view_compact') },
        ]}
      />
    </div>
  );
};

export default DensityToggle;
